export function formatEUR(n, max = 2) {
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: max,
    minimumFractionDigits: max,
  }).format(Number(n || 0));
}

export function formatDate(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" });
  } catch {
    return s;
  }
}

export function formatMonth(ym) {
  if (!ym) return "—";
  const [y, m] = ym.split("-");
  const d = new Date(parseInt(y), parseInt(m) - 1, 1);
  return d.toLocaleDateString("de-DE", { year: "numeric", month: "long" });
}

export function today() {
  return new Date().toISOString().slice(0, 10);
}

// Versteht deutsche Eingaben wie "2.583,42" oder "2583,42" sowie "2583.42"
export function parseAmount(v) {
  if (typeof v === "number") return v;
  if (v === null || v === undefined) return NaN;
  let s = String(v).trim().replace(/\s|€/g, "");
  if (s.includes(",")) s = s.replace(/\./g, "").replace(",", ".");
  else if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, "");
  return parseFloat(s);
}

// Gibt Fehlermeldung zurück, wenn ein Datum ein Jahr außerhalb 2020–2100 hat
export function invalidDateMessage(obj, fields) {
  for (const [key, label] of fields) {
    const v = obj[key];
    if (!v) continue;
    const y = parseInt(String(v).slice(0, 4), 10);
    if (!(y >= 2020 && y <= 2100)) return `${label}: Jahr ${String(v).slice(0, 4)} ist ungültig (erlaubt 2020–2100)`;
  }
  return null;
}
